import { FormattedNumber, Icon, IconMetaphor } from '@vestigas/ui';

type P = {
  iconMetaphor?: IconMetaphor;
  kpiColor?: string;
  label: string;
  previousValue: number | undefined | null;
  tooltip?: string;
  unit?: string;
  value: number | undefined | null;
};

export const getKpiProps = ({
  iconMetaphor,
  kpiColor,
  label,
  previousValue,
  tooltip,
  unit,
  value,
}: P) => {
  const delta = ![null, undefined].includes(previousValue)
    ? (value ?? 0) - (previousValue ?? 0)
    : undefined;
  const deltaPercentage = delta
    ? previousValue === 0
      ? 100
      : (delta / (previousValue ?? 1)) * 100
    : undefined;
  const trend = delta ? (delta > 0 ? 'up' : 'down') : undefined;

  return {
    label,
    previousValue: (
      <FormattedNumber
        className="[&>span:last-child]:pl-[0.25ch]"
        digits={0}
        fallbackValue=""
        unit={deltaPercentage ? '%' : undefined}
        value={deltaPercentage || undefined}
        forceSign
        highContrast
      />
    ),
    tooltip,
    trend,
    value: (
      <>
        {Boolean(iconMetaphor) && (
          <Icon metaphor={iconMetaphor} className={kpiColor} size="md" />
        )}
        <FormattedNumber
          className="[&>span:last-child]:pl-[0.25ch]"
          classNameValue={kpiColor}
          digits={0}
          unit={[null, undefined].includes(value) ? undefined : unit}
          value={value}
          highContrast
        />
      </>
    ),
  };
};
